import { z } from 'zod'

import { BusinessErrorSchema } from 'shared/api/common/schemas/errors'

export const GreetingTextErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('greeting_text'),
})

export const InvalidUrlErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('url'),
})

export const InvalidTimezoneErrorSchema = BusinessErrorSchema.extend({
  field: z.literal('timezone'),
})
